import React, { useState, useEffect } from 'react';
import {
  BreadcrumbPage
} from "../../shared";
import {
  Box,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,

} from '@material-ui/core';
import {

  FormLabel,
  FormControl,
  ListItemText,
  TextField,

  Select,
  InputLabel,
  MenuItem
} from '@mui/material';
import DatePicker from '@mui/lab/DatePicker';
import { useSelector, useDispatch } from 'react-redux';
import { getRequest, putRequest } from "../../services/ApiServices";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { render } from 'react-dom';



import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import axios from "axios";
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import ReactTooltip from "react-tooltip";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { ThemeProvider } from "@mui/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
const useStyles = makeStyles((theme) => ({
  mainBox: {
    boxShadow: "4px 4px 8px 1px #b9b8b8",
    height: "71vh",
  },
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 2px #a1a1a1",
    borderRadius: 8,
 
 

  },
  cont2: {
 
    marginleft: "150px",
  },
  heading: {
    padding: "1px",
    color: "	#1E90FF",
    fontWeight: "bold",

  },
  img1: {
    width: "100%",
    height: "auto",
    marginBottom: "10px",
    maxWidth:"200px"
  }, img2: {
    width: "100%",
    height: "auto",
    maxWidth: "200px"
  },
  img3: {
 
    height: "auto",
 
    maxHeight:"70px"
  },
  btnStyle: {
    background: "#1A1A31 !important",
    float: "right",
    borderRadius: "10px ! important",


    color: "#ffffff !important",

  }, btnStyle1: {
    background: "#1A1A31 !important",
    float: "right",
    borderRadius: "10px ! important",


    color: "#ffffff !important",


  }, 

}));

function Decorbonisation() {
  const BreadcrumbList = [{ name: "Decorbonisation", url: "" }];
  const classes = useStyles();
  const dispatch = useDispatch();
  let theme = createTheme();
  theme = responsiveFontSizes(theme)
  const [value, setValue] = React.useState(0);




  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }


  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  function a11yProps(index) {

    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  useEffect(() => {

  }, []);



  return (
    <>
      <Box pt={0} mx={3} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
        {/* <TabPanel value={value} index={0} className="custom-tab-section"> */}
      </Box>
     <Box
        component="main" p={3} >
        <Grid container>
          <Grid item xs={12}> 

     
       <Grid container spacing={3} className="decorbonationpg">

          <Grid item xs={12} sm={12} md={5}>
          <Box component="div" borderRadius={3} boxShadow={4} className="decin">
            <h3 style={{ color: "#ff4717 ",   margin: "0px 0px 20px 0px" }}>Maress</h3>
              <p style={{  fontWeight: "bold", margin: "0px 0px 20px 0px" }}>Maress connects to vessel data to provide you with
                unique insight on operational footprint and trends.
                Used by vessel owner/operators, contractors and charterers to create better collaboration to meet emission KPIs.
                To learn more about how Maress can be part of your decarbonisation efforts, check <a href="http://www.yxney.com/services" target="_blank" >www.yxney.com/services </a> or reach out on:  <a href="mailto:maress@yxney.com">maress@yxney.com</a>
              </p>
               <Grid container >
                <Grid item xs={12} sm={12} md={12} lg={6}>
                <span><a href="http://www.yxney.com/services" target="_blank"><img className={classes.img1} src="\assets\images\Maress Logo.png" ></img></a></span>
                </Grid> <Grid item xs={12} sm={12} md={12} lg={6}>
                <Button style={{textAlign: "center", padding: "10px 20px", lineHeight:"16px"}} className={classes.btnStyle} href="mailto:team@yxney.com?subject=Email">Contact VPS Account <br />
                  Manager</Button>
                  </Grid>
</Grid>
</Box>
          </Grid>
          <Grid item xs={12} sm={12} md={7} >
           <Box component="div" borderRadius={3} boxShadow={4} className="decin">
            <h3 style={{   margin: "0px 0px 20px 0px", color: "#ff4717 "}}>VPS Core</h3>

                <p style = {
                  {
                    
                    fontWeight: "bold",
                    margin: "0px 0px 20px 0px"
                  }
                } > Easily calculate and visualize your vessel - and fleet´ s carbon intensity with our coming software.In addition to being a IMO requirement from 2023 the CII can be used
                for strategic planning purposes.VPS CORE is being built to provide our clients with scenario planning functionality that will help your company take a leadership role in the industry transition.
                  To sign-up, and get ready for the 2023 requirements, reach out to your VPS account manager or on <a href="mailto:team@yxney.com">team@yxney.com</a>
                </p>
                <Grid container >
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <span><a href="http://www.yxney.com/services" target="_blank" ><img style={{ maxWidth:"175px"}} className={classes.img1} src="\assets\images\vpscore.jpg" ></img></a></span>
                 </Grid> <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Button style={{textAlign: 'center', padding: "10px 20px" , lineHeight: "16px"}} className={classes.btnStyle} href="mailto:team@yxney.com?subject=Email">Contact VPS Account <br />
                    {/* //https://qlik.portstats.nl/azure/hub/ */}
                    Manager</Button>
                </Grid>
                 </Grid>
                </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={5} >
           <Box component="div" borderRadius={3} boxShadow={4} className="decin">
            <h3 style={{  color: "#ff4717 ", margin: "0px 0px 20px 0px" }}>No<sub>x</sub>Digital</h3>
              <p style = {
                {
                 
                  fontWeight: "bold",
                  margin: "0px 0px 20px 0px"
                }
              } > The easy and most correct method
              for calculation of taxable NOx emissions in Norwegian waters. Sleep better knowing the numbers you report are accurate.
                To learn more, and get started with hassle-free NOx calculations, check <a href="http://www.noxdigital.no" target="_blank"> www.noxdigital.no </a>or reach out on: <a href="mailto:team@yxney.com">team@yxney.com</a>
              </p>

              <Grid container >
                <Grid item xs={12} sm={12} md={12} lg={6}>
                <span><a href="http://www.noxdigital.no" target="_blank"> <img className={classes.img3} src="\assets\images\NOxDigital Logo.png"></img></a></span>
                </Grid> <Grid item xs={12} sm={12} md={12} lg={6}>
                <Button style={{textAlign: "center", padding: "10px 20px", lineHeight: "16px"}} className={classes.btnStyle} href="mailto:team@yxney.com?subject=Email">Contact VPS Account <br />
                  Manager</Button>
                   </Grid>
              </Grid>
              </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={7} >
            <Box component="div" borderRadius={3} boxShadow={4} className="decin">
              <h3 style={{  color: "#ff4717 ", margin:"0px 0px 20px 0px" }}> Decarbonisation Advisory</h3>
                <p style={{   fontWeight: "bold" }}> The maritime industry is changing fast, with ambitious emission targets and requirements. New technologies and fuels are coming into the market. In this dynamic landscape many ship owners are looking for answers - both on how to optimize operations, and how to adapt to changing business drivers.
                  Engage in a conversation with our stellar advisors on  <a href="mailto:team@yxney.com">team@yxney.com</a> to discuss how the VPS Decarbonisation Advisory team may be a partner on your journey.
                </p>
                
               <Grid container >
                <Grid item xs={12} sm={12} md={12} lg={6}>
                </Grid> <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Button style={{ textAlign: 'center', lineHeight:"16px", padding: "10px 20px" }} className={classes.btnStyle1} href="mailto:team@yxney.com?subject=Email">Contact VPS Account <br />
                    Manager</Button>
                     </Grid>
                      </Grid>
              </Box>  
          </Grid>

        
         
           
         
       
        </Grid>
        {/* </TabPanel> */}
      </Grid>
      </Grid>
      </Box>
    </>
  );
}

export default Decorbonisation;